import React, { useEffect } from 'react'
import "../Styles/User_section_home.css"
import RightArrowIcon from '../Images/ArrowCircleRight.png'
import customer from '../Images/customer_img.png'
import { useNavigate } from 'react-router-dom'

// Ensure the effect runs only once on mount

function User_section() {
    const navigate = useNavigate();
useEffect(() => {
// counter animation

function animateCounter(el) {
  const target = +el.getAttribute("data-target");
  let start = 0;
  const duration = 2000; // animation time in ms
  const startTime = performance.now();

  function easeOutQuad(t) {
    return t * (2 - t); // smooth start → slow end
  }

  function update(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1); // max 1
    const easedProgress = easeOutQuad(progress);

    el.textContent = Math.floor(easedProgress * target).toLocaleString();

    if (progress < 1) {
      requestAnimationFrame(update);
    } else {
    //   el.textContent = target.toLocaleString(); 
    //   el.textContent = "8.3k"; 
        if (el.id === "userCount") {
            el.textContent = "8.3k"; // Set to 8.3k for user count
        } else if (el.id === "number_of_trp") {
            el.textContent = "50+"; // Set to 50+ for trip count
        }
         else if (el.id === "number_of_Hotel") {
            el.textContent = "1K+"; // Set to 50+ for trip count
        }
    }
  }

  requestAnimationFrame(update);
}

const counters = document.querySelectorAll(".counter");

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting && !entry.target.classList.contains("show")) {
      entry.target.classList.add("show");
      animateCounter(entry.target);
    }
  });
}, { threshold: 0.5 });

counters.forEach(counter => observer.observe(counter));

}, []); 



    return (
        <>
            {/* User Section  */}

            <div className="user-section">
                <div className="user-section-content">
                    <div className='user_section_animation'>
                        <span>Join us,</span>
                        <span>Share the great places,</span>
                        <span>Explore with us</span>
                    </div>
                    <div className='user_number_div'>
                        <div className='joined_user_div'>
                            <div className='joined_user_number counter' data-target="8300" id='userCount'>8.3k</div>
                            <div className='joined_user_name'>User Joined</div>
                        </div>
                        <div className='trip_user_div'>
                            <div className='trip_user_number counter' data-target="50" id='number_of_trp'>50+</div>
                            <div className='trip_user_name'>Trip Planned</div>
                        </div>
                        <div className='trip_user_div'>
                            <div className='trip_user_number counter' data-target="1000" id='number_of_hotel'>1k+</div>
                            <div className='trip_user_name'>Hotel Booked User</div> 
                        </div>
                        {/* <div style={{display:"flex",alignItems:"center"}}><button className="get-started" ><span style={{ fontWeight: "600" }} onClick={()=>{navigate("/tour/grouptour")}}>Enjoy With Group</span><span style={{ display: "flex", alignItems: "center" }}><img src={RightArrowIcon} alt='icon' width="25px" height="25px" /></span></button></div> */}
                    </div>
                </div>
                <div className="user-section-content_right">
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%",gap: "1rem" }}>
                        <div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>Join the folks</div>
                        <div>
                            <div class="customer-card">
                                <div class="circle"></div>
                                <div class="card-content">
                                    <h2>5K+</h2>
                                    <p>Happy customer</p>
                                    <div class="avatars">
                                        <img src={customer} alt="Customer" />
                                        <img src={customer} alt="Customer" />
                                        <img src={customer} alt="Customer" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className='user_paragraph'>Over the years, we’ve helped thousands of travelers explore breathtaking destinations across the globe. From solo adventurers to family getaways, our passion lies in crafting journeys that go beyond expectations.</div>
                </div>

            </div>
        </>

    )
}

export default User_section